const radiosSelector = '[data-shipping-rate=radio]';
const optionsSelector = '[data-shipping-rate=option]';

const init = () => {
  $(document).on('change', radiosSelector, (event) => {
    const $target = $(event.target);
    const $option = $target.parents(optionsSelector);

    if ($target.is(':checked')) {
      $(radiosSelector).not($target).trigger('change');
      $option.addClass('rate-selected');
    } else {
      $option.removeClass('rate-selected');
    }
  });
};

export default { init };



// WEBPACK FOOTER //
// ./src/components/legacy/shipping_labels/rates_form.js